module.exports = __webpack_public_path__ + "static/img/200.779ae72.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/s31/pop/200.png
// module id = 5tjg
// module chunks = 2